import { z } from 'zod';

export const singleTeamAnthemSchema = z.object({
  lyrics: z.string().optional(),
  file: z.any().optional(),
});

export type SingleTeamAnthemFormData = z.infer<typeof singleTeamAnthemSchema>;
